export default {

    async validateConfig(authConfigReq, module) {
        const requestBundleId = module.replace(/\./g, ':');

        return authConfigReq.validateConfig(requestBundleId);
    }
};
